/**
 * Page wrapper — hybrid desktop layout.
 *
 * mode="dashboard" → centred column, max-width, tab-bar safe padding.
 *   Use for: Home, Watchlist, History, AddMovie, Rate, Group, Login, Signup.
 *
 * mode="cinema" → full-bleed, vertically centred, dramatic.
 *   Use for: Wheel, Result. No max-width constraint.
 *
 * On desktop both modes stay centred — no more left-anchored mobile strip.
 */
export default function Page({
  children,
  mode = 'dashboard',
  className = '',
  bg,
}) {
  if (mode === 'cinema') {
    return (
      <div
        className={`min-h-[100dvh] w-full flex flex-col items-center justify-center px-6 py-10 relative ${className}`}
        style={bg ? { background: bg } : undefined}
      >
        {children}
      </div>
    )
  }

  // dashboard — generous breathing room, wider column, looser vertical rhythm
  return (
    <div className="min-h-[100dvh] w-full flex justify-center">
      <div
        className={`w-full max-w-2xl px-8 pt-14 sm:px-12 sm:pt-20 ${className}`}
        style={{ paddingBottom: '120px' }}
      >
        {children}
      </div>
    </div>
  )
}
